import { render } from "./DailyMessage.vue?vue&type=template&id=33470530"
import script from "./DailyMessage.vue?vue&type=script&lang=js"
export * from "./DailyMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__